import React from 'react';
import { Square, Video, Clock, Bot, Loader2 } from 'lucide-react';

const ActiveMeetings = ({ meetings, joiningMeetings = [], onStop, loading, darkMode }) => {
  const hasMeetings = (meetings && meetings.length > 0) || (joiningMeetings && joiningMeetings.length > 0);

  if (!hasMeetings) {
    return null;
  }

  const formatTime = (date) => {
    if (!date) return '';
    return new Date(date).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  };

  return (
    <div className={`rounded-2xl border p-4 mb-4
      ${darkMode 
        ? 'bg-primary/60 border-emerald-500/30' 
        : 'bg-emerald-50/80 border-emerald-200'}
    `}>
      <div className="flex items-center gap-2 mb-3">
        <div className={`w-2 h-2 rounded-full animate-pulse ${darkMode ? 'bg-emerald-400' : 'bg-emerald-500'}`} />
        <span className={`text-sm font-medium uppercase tracking-wider ${darkMode ? 'text-emerald-400' : 'text-emerald-600'}`}>
          Active Meetings ({meetings.length + joiningMeetings.length})
        </span>
      </div>
      
      <div className="space-y-3">
        {/* Joining Meetings */}
        {joiningMeetings.map((meeting) => (
          <div 
            key={meeting.id}
            className={`flex items-center justify-between p-3 rounded-xl transition-all border border-dashed animate-pulse
              ${darkMode 
                ? 'bg-amber-500/10 border-amber-500/30' 
                : 'bg-amber-50 border-amber-200'}
            `}
          >
            <div className="flex items-center gap-3 flex-1 min-w-0">
              <div className={`p-2 rounded-lg ${darkMode ? 'bg-amber-500/20' : 'bg-amber-100'}`}>
                <Loader2 size={16} className={`animate-spin ${darkMode ? 'text-amber-400' : 'text-amber-600'}`} />
              </div>
              
              <div className="flex-1 min-w-0">
                <p className={`font-light text-sm truncate ${darkMode ? 'text-white' : 'text-slate-900'}`}>
                  {meeting.meeting_title || 'Instant Meeting'}
                </p>
                <div className="flex items-center gap-2 mt-1">
                  <span className={`text-xs font-bold uppercase tracking-wider ${darkMode ? 'text-amber-400' : 'text-amber-600'}`}>
                    Joining...
                  </span>
                </div>
              </div>
            </div>
          </div>
        ))}

        {/* Active Meetings */}
        {meetings.map((meeting) => (
          <div 
            key={meeting.meeting_id}
            className={`flex items-center justify-between p-3 rounded-xl transition-all
              ${darkMode 
                ? 'bg-primary/50 hover:bg-primary/70' 
                : 'bg-white hover:bg-white/80'}
            `}
          >
            <div className="flex items-center gap-3 flex-1 min-w-0">
              <div className={`p-2 rounded-lg ${darkMode ? 'bg-emerald-500/20' : 'bg-emerald-100'}`}>
                <Video size={16} className={darkMode ? 'text-emerald-400' : 'text-emerald-600'} />
              </div>
              
              <div className="flex-1 min-w-0">
                <p className={`font-light text-sm truncate ${darkMode ? 'text-white' : 'text-slate-900'}`}>
                  {meeting.meeting_title || 'Instant Meeting'}
                </p>
                <div className="flex items-center gap-2 mt-1">
                  <span className={`text-[10px] font-bold uppercase tracking-wider px-2 py-0.5 rounded-full ${
                    meeting.status === 'running' ? 'bg-emerald-500/10 text-emerald-500' :
                    meeting.status === 'error' ? 'bg-red-500/10 text-red-500' :
                    meeting.status === 'starting' ? 'bg-amber-500/10 text-amber-500' :
                    'bg-slate-500/10 text-slate-500'
                  }`}>
                    {meeting.status || 'Active'}
                  </span>
                  <Clock size={12} className={darkMode ? 'text-slate-500' : 'text-slate-400'} />
                  <span className={`text-xs font-light ${darkMode ? 'text-slate-400' : 'text-slate-500'}`}>
                    Started {formatTime(meeting.last_started_at)}
                  </span>
                </div>
              </div>
            </div>
            
            <button
              onClick={() => onStop(meeting.meeting_id)}
              disabled={loading}
              className={`flex items-center gap-2 px-4 py-2 rounded-xl font-medium text-sm transition-all
                ${loading 
                  ? 'opacity-50 cursor-not-allowed' 
                  : 'hover:scale-105 active:scale-95'}
                ${darkMode 
                  ? 'bg-red-500/20 text-red-400 hover:bg-red-500/30' 
                  : 'bg-red-100 text-red-600 hover:bg-red-200'}
              `}
            >
              <Square size={14} fill="currentColor" />
              Stop
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ActiveMeetings;
